module.exports = __webpack_public_path__ + "img/desktop-vb-banner.cb8db726.png";